import React, { useState } from 'react';
import './NavBar.css';
import Logo from '../../assets/TubeStampLogo.svg';

function NavBar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <span className="navbar-brand">TimeStamps</span>
      </div>

      <div className={`navbar-center ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <button className="mobile-menu-close" onClick={toggleMobileMenu}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <span className="navbar-link">About us</span>
        <span className="navbar-link">Pricing</span>
        {/* Mobile only CTA inside menu for better UX */}
        <div className="mobile-cta-container">
          <button className="navbar-cta mobile-cta">Sign In</button>
        </div>
      </div>

      <div className="navbar-right">
        <button className="navbar-cta desktop-cta">Sign In</button>
        <button className={`hamburger-menu ${isMobileMenuOpen ? 'hidden' : ''}`} onClick={toggleMobileMenu} aria-label="Toggle menu">
          <span className={`hamburger-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </nav>
  );
}

export default NavBar;